import {SERVICES} from '@/const/services';

const PREFIX_RECEIVE = `${SERVICES.STATIC_URL}/pubimg/`;
const PREFIX_RECEIVE_V1 = `https://img.phemex.com/v1`;

export const WALLET_IMAGES = {
  MetaMask: `${PREFIX_RECEIVE_V1}/cef5dd17/transparent-metamask.svg`,
  WalletConnect: `${PREFIX_RECEIVE_V1}/b18891a8/wallet-connect.svg`,
  Coinbase: `${PREFIX_RECEIVE_V1}/coinbase-wallet.png`,
  Zerion: `${PREFIX_RECEIVE_V1}/3c659bf5/zerion-wallet.png`,
};

export const CHAIN_IMAGES = {
  ARETH: `${PREFIX_RECEIVE_V1}/bdbca23d/arbitrum-chain.png`,
  ETH: `${PREFIX_RECEIVE_V1}/72268b10/ethereum-chain.png`,
  FTM: `${PREFIX_RECEIVE_V1}/e1a781dd/fantom-chain.png`,
  BNB: `${PREFIX_RECEIVE_V1}/70793435/bsc-chain.png`,
  MATIC: `${PREFIX_RECEIVE_V1}/c2c47509/polygon-chain.png`,
  AVAX: `${PREFIX_RECEIVE_V1}/0a783e3b/avalanchec-chain.png`,
};

export const CHAIN_ID_IAMGES = {
  4: CHAIN_IMAGES.ETH,
  43: CHAIN_IMAGES.MATIC,
  46: CHAIN_IMAGES.FTM,
  61: CHAIN_IMAGES.BNB,
  157: CHAIN_IMAGES.AVAX,
  261: CHAIN_IMAGES.ARETH,
};

export const PUB_IMAGES = {
  WHITE_DEPOSIT: 'b30efec9582b6a734041786880cb94117fd079b19b68ba4bca37dce81710c675.png',
  WHITE_WITHDRAW: 'a1ef56352fbc749116fb129a1f7e40b5d3e55b4f1d741fd3e7ae84177d6b75e2.png',
  SOULPASS: '2ec9be12e8f26e4bba0f285e0fbc05e93b7b23fae3b5a53aff67428e69af2a9c.png',
  ACCOUNT: '1109998ee93cb7cd0d3acdf3e209ffcfbfe89df0fc281f3b6b5f5843e3f4a5e2.png',
  LOGOUT: 'c87079b986eb256d02ad029f22bb676501a9b49be23bcb3b4629ad6abec26031.png',
  DOWNLOAD: 'e360f59f7f144e0a97d93755b28dd31e554a475271f9001f470a13f566834ec5.png',
  LANGUAGE: '59b60c001f7d4202ef739bc5b76f4a4cd3c59d4b9a4775696959758eaa01fdf9.png',
  TWITTER: '37996260a4efb88696d9b176c08977cccfdd3772ca08871ffcec6b7c986b5323.png',
  DISCORD: '3efeca17558d14e0e1e7c79b5c3da20d638763942a7b4f702bfd446cfa646e2b.png',
  TELEAGRAM: 'd10b4b984b2ab1ae4acd9b3fe6b8ac53f22de7ee14356d535bee9a3ba5800b5f.png',
  LINKEDIN: 'd5b2d9b72d8abb42f38d50f15982490d34b97fc52ea6384a799e5d30dfcd9523.png',
};

Object.keys(PUB_IMAGES)
  .filter((key) => PUB_IMAGES[key])
  .forEach((key) => (PUB_IMAGES[key] = [PREFIX_RECEIVE, PUB_IMAGES[key]].join('')));

export function getWalletImage(walletName) {
  return WALLET_IMAGES[walletName] || WALLET_IMAGES.WalletConnect;
}

export function getChainImage(chain) {
  return CHAIN_IMAGES[chain] || CHAIN_ID_IAMGES[chain] || '';
}
